<template>
  <div class="print-step2">
    <h4>乘机人信息</h4>
    <components v-bind:is="compName" :checkinList="checkinList" @selectTrip="selectTrip"></components>
    <p style="text-align: center" v-if="!compName">
      <a-spin tip="正在加载乘机人信息..." />
    </p>
    <div class="print-operation">
      <a-button v-if="!ready" size="large" class="print-btn">补打登机牌</a-button>
      <div v-else>
        <p v-if="airline === 'Y8' && banCities">当前选择的航班无法打印登机牌</p>
        <a-button v-else type="primary" size="large" class="print-btn" @click="handlePrintPDF">补打登机牌</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { checkinTrip, checkinData, reprintBoarding } from '@/apis/checkin'
import axios from 'axios'
import moment from 'moment'
import CheckInList from '@/components/checkin/selectCheckin'
import { getBanCities } from '../../checkin/data'

export default {
  props: {
    stepData: Object
  },
  data () {
    return {
      compName: '',
      checkinList: [],
      selectIndex: -1,
      ready: false,
      flightData: {},
      airline: window.__MICRO_ROOT__?.airline,
      banCities: false
    }
  },
  created () {
    this.getFlightData()
  },
  methods: {
    async getFlightData () {
      const data = {
        ...this.stepData
      }
      if (data.certType === 'ID_CARD') {
        data.certType = 'NI'
      }
      try {
        const result = await checkinTrip({
          ...data,
          slideCaptcha: new Date().getTime()
        })
        result.forEach((item, index) => {
          if (item.depTime) {
            let timeFormat = moment(item.depTime).format()
            item.depTimeFormat = timeFormat.split('T')[1].slice(0, 5)
            item.depDateFormat = timeFormat.split('T')[0]
          } else {
            item.depTimeFormat = ''
            item.depDateFormat = ''
          }
          if (item.arrTime) {
            item.arrTimeFormat = moment(item.arrTime).format().split('T')[1].slice(0, 5)
          } else {
            item.arrTimeFormat = ''
          }

          if (item.status === 'OPEN FOR USE') {
            item.statusText = '可值机'
            item.disabled = true
          } else {
            if (item.status === 'CHECKED IN') {
              item.statusText = '已值机'
            } else {
              item.statusText = '不可值机'
              item.disabled = true
            }
          }
          this.checkinList.push(item)
        })
        this.compName = 'CheckInList'
      } catch (err) {
        this.$message.error(err.message)
        this.$emit('callback', 1)
      }
    },
    async selectTrip (index) {
      this.isSelect = true
      this.selectIndex = index
      let flight = this.checkinList[index]
      this.flightData = {
        airline: flight.airline,
        arrCode: flight.arrCode,
        cabin: flight.cabin,
        certNo: flight.certNo,
        depCode: flight.depCode,
        depTime: flight.depTime,
        flightNo: flight.flightNo,
        ticketNo: flight.ticketNo,
        certType: 'TN' // 写死证件类型为票号
      }
      try {
        const result = await checkinData(this.flightData)
        if (!result.seatNumber) {
          this.$message.error('您在此航班尚未值机，无法补打登机牌')
        } else {
          this.flightData.boardingNumber = result.boardingNumber
          this.flightData.seatNum = result.seatNumber
          this.flightData.passengerName = result.passengerName
          this.flightData.passengerType = result.passengerType
          this.ready = true
          this.banCities = getBanCities(result.depCode, result.cabin)
        }
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    async handlePrintPDF () {
      let data = Object.assign({}, this.flightData)
      const psgData = this.checkinList[this.selectIndex]
      data.tourIndex = psgData.tourIndex
      data.reissue = 'Y' // 补打登机牌传 Y
      try {
        const result = await reprintBoarding(data)
        const dataFlow = result
        this.outputPDF(dataFlow, data)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async outputPDF (dataFlow, data) {
      const { depTime, tourIndex } = data
      const airline = window.__MICRO_ROOT__?.airline

      axios({
        method: 'post',
        url: '/api/checkin/pdfBoardingV2',
        headers: {
          airline,
          channel: 'C' + airline
        },
        data: {
          dataFlow: dataFlow,
          depTime,
          tourIndex
        },
        responseType: 'blob'
      }).then(({ status, data }) => {
        if (status === 200) {
          if (!window.Blob) {
            this.$message.error('该浏览器不支持数据流下载，请更换浏览器')
            return
          }
          const blob = new Blob([data])
          const fileName = '登机牌.pdf'
          if ('download' in document.createElement('a')) {
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          } else {
            navigator.msSaveBlob(blob, fileName)
          }
        } else {
          this.$message.error('网络异常，请稍后再试！')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    }
  },
  components: {
    CheckInList
  }
}
</script>
<style lang="less" scoped>
.print-step2 {
  padding-top: 30px;
  h4 {
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }
  .print-operation {
    padding-top: 50px;
    text-align: center;
    .print-btn {
      padding: 0 40px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .print-step2 {
    padding-top: 15px;
    h4 {
      margin-left: 10px;
    }
    .print-operation {
      .print-btn {
        display: block;
        width: 96%;
        margin: 0 auto;
      }
    }
  }
}
</style>
